import React, {Fragment, useState} from 'react';
import Header from '../../components/Header/Header';
import PageTitle from '../../components/pagetitle/PageTitle';
import Scrollbar from '../../components/scrollbar/scrollbar';
import Footer from '../../components/business/Footer/Footer';
import Bg from '../../images/backgrounds/onze_diensten_image.webp';
import srImg from '../../images/services/quickscan/quickscan_info.webp';
import {AccordionBody, AccordionHeader, AccordionItem, Accordion} from "reactstrap";

const Partners = (props) => {

    const [open, setOpen] = useState('1');
    const toggle = (id) => {
        if (open === id) {
            setOpen();
        } else {
            setOpen(id);
        }
    };

    return (
        <Fragment>

            <Header />
            <main className="page_content about-page">
                <PageTitle
                    pageTitle={'Samen Sterker: Word onze Strategische partner'}
                    bgImage={Bg}
                />

                {/* Introductie */}
                <section className="about_section section_space bg-light">
                    <div className="container">
                        <div className="row align-items-center justify-content-lg-between">
                            <div className="col-lg-5 order-lg-last">
                                <div className="team_cartoon_image">
                                    <img src={srImg} alt="Service Cartoon" />
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="about_content">
                                    <div className="heading_block">
                                        <h2 className="heading_text">Waarom een partnerschap met ons?</h2>
                                        <p className="heading_description mb-0">
                                            Bij <strong>Praeventor</strong> geloven we in de kracht van samenwerking.
                                            Ons doel is om bedrijven en experts in cybersecurity en webveiligheid
                                            samen te brengen om innovatie te stimuleren, gezamenlijke successen te behalen
                                            en onze klanten de beste oplossingen te bieden.
                                            <br /><br />
                                            Daarom zoeken we strategische partners die samen met ons willen bouwen
                                            aan een veilige digitale toekomst.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Focusgebieden */}
                <section className="section_space bg-white">
                    <div className="container">
                        <h3 className="text-center mb-5">Onze focusgebieden voor partnerschappen</h3>
                        <div className="partners_faq accordion" id="partners_faq">
                            <Accordion open={open} toggle={toggle} className="accordion" id="service_process_faq">
                                <AccordionItem className="accordion-item">
                                    <AccordionHeader targetId="1">
                                        Een gedeelde missie in cybersecurity
                                    </AccordionHeader>
                                    <div className="accordion-body-container">
                                        <AccordionBody accordionId="1" className="acc_body">
                                            <p>
                                                Cyberveiligheid is geen luxe, het is een noodzaak.
                                                Samen met jou willen we bedrijven beschermen tegen groeiende
                                                digitale dreigingen en een beweging creëren die cybersecurity
                                                toegankelijk maakt voor iedereen. Als partner draag je bij aan
                                                deze missie en deel je mee in het succes.
                                            </p>
                                        </AccordionBody>
                                    </div>
                                </AccordionItem>

                                <AccordionItem className="accordion-item">
                                    <AccordionHeader targetId="2">
                                        Geloof in innovatie en visie
                                    </AccordionHeader>
                                    <div className="accordion-body-container">
                                        <AccordionBody accordionId="2" className="acc_body">
                                            <p>
                                                Wij werken met een helder doel: innovatieve oplossingen bieden die bedrijven sterker maken in hun digitale beveiliging. Door samen te werken, combineer je jouw kracht met onze ideeën, waardoor we samen een grotere impact kunnen maken.
                                            </p>
                                        </AccordionBody>
                                    </div>
                                </AccordionItem>

                                <AccordionItem className="accordion-item">
                                    <AccordionHeader targetId="3">
                                        Een sterk fundament voor gezamenlijke groei
                                    </AccordionHeader>
                                    <div className="accordion-body-container">
                                        <AccordionBody accordionId="3" className="acc_body">
                                            <p>
                                                We staan aan het begin van iets groots, en jij kunt ons helpen om dat verder te ontwikkelen. Of je nu ervaring hebt in onze sector of een partner zoekt met wie je een gemeenschappelijke groeiambitie deelt, jouw betrokkenheid helpt ons het verschil te maken.
                                            </p>
                                        </AccordionBody>
                                    </div>
                                </AccordionItem>

                                <AccordionItem className="accordion-item">
                                    <AccordionHeader targetId="4">
                                        Toegang tot een groeiend netwerk en expertise
                                    </AccordionHeader>
                                    <div className="accordion-body-container">
                                        <AccordionBody accordionId="4" className="acc_body">
                                            <p>
                                                Als partner van Praeventor profiteer je van ons uitgebreide netwerk binnen de cybersecuritywereld. We zijn actief in toonaangevende communities zoals DEF CON, r/NetSec en The Ethical Hacker Network, en we delen onze kennis via exclusieve trainingen, workshops, en rapporten. Jouw organisatie kan deze waardevolle connecties benutten en een nog grotere impact maken.
                                            </p>
                                        </AccordionBody>

                                    </div>
                                </AccordionItem>
                                <AccordionItem className="accordion-item">
                                    <AccordionHeader targetId="5">
                                        Gezamenlijke positionering als thought leader
                                    </AccordionHeader>
                                    <div className="accordion-body-container">
                                        <AccordionBody accordionId="5" className="acc_body">
                                            <p>
                                                Samenwerken met ons betekent dat je jouw organisatie positioneert
                                                als een pionier in cybersecurity. Door onze gecombineerde expertise,
                                                visie en technologie staan we sterker en krijgen we meer zichtbaarheid in de markt. Jouw betrokkenheid helpt niet alleen ons groeien, maar versterkt ook jouw positie als vooruitstrevende speler binnen de sector.
                                            </p>
                                        </AccordionBody>
                                        <AccordionBody accordionId="2" className="acc_body">
                                            <div className="text_a">A.</div>
                                            <p>
                                                Additional content explaining our unique approach compared to other cybersecurity companies. We help companies scale without compromising on security.
                                            </p>
                                        </AccordionBody>
                                    </div>
                                </AccordionItem>
                            </Accordion>
                        </div>
                    </div>
                </section>

                {/* Voordelen voor Partners */}
                <section className="section_space bg-light">
                    <div className="container">
                        <h3 className="text-center mb-5">Wat wij bieden aan onze partners</h3>
                        <div className="row">
                            <div className="col-lg-4 mb-4">
                                <div className="benefit_card">
                                    <h4 className="benefit_title">Een kans om impact te maken</h4>
                                    <p>
                                        Help ons een leidende rol te spelen in de cybersecuritywereld en krijg erkenning als mede-bouwer van ons succes.
                                    </p>
                                </div>
                            </div>
                            <div className="col-lg-4 mb-4">
                                <div className="benefit_card">
                                    <h4 className="benefit_title">Toegang tot expertise en innovatie</h4>
                                    <p>
                                        Werk samen met een team dat gedreven wordt door de nieuwste technologieën en inzichten.
                                    </p>
                                </div>
                            </div>
                            <div className="col-lg-4 mb-4">
                                <div className="benefit_card">
                                    <h4 className="benefit_title">Een duurzaam partnerschap</h4>
                                    <p>
                                        Onze samenwerking draait om wederzijds succes, waarbij
                                        we elkaar versterken en groeien als een team.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>


                {/* Sluit je aan bij de Missie */}
                <section className="section_space">
                    <div className="container">
                        <h3 className="text-center mb-5">Sluit je aan bij onze missie</h3>
                        <div className="text-center">
                            <div className="col-lg-12 mb-4">
                                <div>
                                    <p>
                                        Geloof jij in onze visie? Zie je kansen om samen te bouwen aan een sterker,
                                        veiliger digitaal ecosysteem? Dan nodigen we je uit om samen met ons dit avontuur aan te gaan. Laten we samen groeien, leren en een impact maken die verder gaat dan onszelf.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="text-center">
                            <h5 className="benefit_title">Interesse?</h5>
                            <p>
                                Laten we in gesprek gaan! Neem contact op via <a href="mailto:info@praeventor.nl">info@praeventor.nl</a> en ontdek hoe we samen verschil kunnen maken.
                            </p>
                        </div>
                    </div>
                </section>
            </main>
            <Footer />
            <Scrollbar />
        </Fragment>
    );
};

export default Partners;
